import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  header: {
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  plateImage: {
    width: 96,
    height: 56,
    objectFit: "contain",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 4,
    backgroundColor: theme.palette.background.default,
    flexShrink: 0,
  },
  platePlaceholder: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 96,
    height: 56,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 4,
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.secondary,
    flexShrink: 0,
  },
  plateText: {
    lineHeight: 1.1,
  },
  confidence: {
    color: theme.palette.text.secondary,
  },
  contextImage: {
    width: "100%",
    maxHeight: 240,
    objectFit: "contain",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 4,
    backgroundColor: theme.palette.background.default,
    display: "block",
  },
  contextPlaceholder: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: 200,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 4,
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.secondary,
  },
}));
